module.exports = __webpack_public_path__ + "static/media/kyla-gregory-resume.d262bebf.pdf";